module.exports = __webpack_public_path__ + "img/qatar.239a10cc.png";